import React, { Component, useEffect } from 'react';
import '../styles/App.css';
import "aos/dist/aos.css";
import Aos from 'aos';
import logoMain from '../assets/header2.png';
import twitter from '../assets/x.png';
import teleg from '../assets/tg.png';
import discord from '../assets/discord.png';
import download from '../assets/download.png';
import coins from '../assets/3d-cash-money.png';
import note1 from '../assets/note2.png';
import note2 from '../assets/note3.png';
import mic from '../assets/3dmic.png';

const Stry = () => {
    useEffect(() => {
        Aos.init({ duration: 4000 });
    }, [])
}

const xLink = () => {
    window.open("#");;
}

const telegLink = () => {
    window.open("#");;
}

const discordLink = () => {
    window.open("https://discord.gg/QA3e36Yh");;
}

class Footer extends Component {
    telegLink
    render() {
        return (

            <div class="boxWrap2Footer">
                <img className='mic2' src={mic} />

                <div className='coinsContainer'>
                    <img className='coins' src={coins} />
                    <img className='note1' src={note1} />
                    <img className='note2' src={note2} />
                </div>
                <div class="footer">
                    <img className='footerH' src={logoMain} />
                    <div class="conT2Footer">We aim to become the largest sustainable music and album production platform in Asia,
                        dedicated to discovering and nurturing talented artists.</div>

                    <div class="iconsF">
                        <img onClick={xLink} src={twitter} />
                        <img onClick={telegLink} src={teleg} />
                        <img onClick={discordLink} src={discord} />
                        <a href="/whitepaper(EN).pdf" download>
                            <img src={download} alt="Download White Paper" />
                        </a>
                    </div>
                </div>

                <div class="copyright">Copyright © 2025 NFT BUNDA ANGELS. All Rights Reserved</div>
            </div>
        )
    }
}

export default Footer;

